/**
 * 默认页面背景图（未达黄金段位时展示），与 AppLayout 使用同一路径
 */
export const DEFAULT_BACKGROUND_IMAGE = '/image/tower.png'

let preloaded = false

/**
 * 在后台预加载默认背景图，便于进入应用后直接显示（利用浏览器缓存，下次访问也可快速显示）
 * 不阻塞 UI，不抛错
 */
export function preloadDefaultBackground() {
  if (preloaded) return
  preloaded = true
  try {
    const img = new Image()
    img.onload = img.onerror = () => {}
    img.src = DEFAULT_BACKGROUND_IMAGE
  } catch {
    preloaded = false
  }
}
